<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('ects_panel')"
                        :is-filter="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('ects_panel')"
                              :is-filter="false" />
            </template>
            <b-row>
                <b-col md="12">
                    <b-button
                        v-if="checkPermission('ectspage_store')"
                        variant="outline-primary"
                        @click="openModal('new', null)"><i class="ri-add-line"></i> {{ $t('add_new') }}</b-button>
                </b-col>
                <b-col md="12">
                    <b-row v-for="(parent, index) in pageData" :key="index">
                        <b-col md="12" class="d-flex justify-content-left">
                            <b-button variant="link"
                                      @click="openCollapse('parent',index)">
                                <b><i class="ri-corner-down-right-line"></i> {{ getLocaleText(parent, 'header') }}</b>
                            </b-button>
                                <b-button variant="link"
                                          v-if="checkPermission('ectspage_update')"
                                          @click="openModal('edit', parent, parent)"
                                          class="p-0 font-size-16"
                                          :title="$t('edit')"><i class="ri-edit-box-fill"></i></b-button>
                                <b-button variant="link"
                                          v-if="checkPermission('ectspage_delete')"
                                          @click="removePage(parent)"
                                          class="pl-1 pr-0 font-size-16"
                                          :title="$t('delete')"><i class="ri-delete-bin-2-line"></i></b-button>
                                <b-button variant="link" :class="{'pl-1':true, 'pr-0':true, 'font-size-16':true, 'text-success':parent.is_visible ? true : false, 'text-danger':parent.is_visible ? false : true}" :title="parent.is_visible ? $t('visibility')+' : '+$t('active') : $t('visibility')+' : '+$t('passive')">
                                    <i class="ri-computer-fill"></i>
                                </b-button>
                                <b-button variant="link" :class="{'pl-1':true, 'font-size-16':true, 'text-success':parent.is_active ? true : false, 'text-danger':parent.is_active ? false : true}" :title="parent.is_active ? $t('status')+' : '+$t('active') : $t('visibility')+' : '+$t('passive')">
                                    <i class="ri-focus-fill"></i>
                                </b-button>
                            </b-col>
                            <b-col md="12">
                                <b-collapse :id="`parent-${index}`" accordion="my-accordion">
                                    <b-col md="12">
                                        <b-button variant="link"
                                                  v-if="checkPermission('ectspage_store')"
                                                  @click="openModal('new', parent)"><i class="ri-add-line"></i> {{ $t('add_new') }}</b-button>
                                    </b-col>
                                    <b-row v-for="(child, key) in parent.children" :key="key">
                                        <b-col md="12" class="ml-3 d-flex justify-content-left">
                                            <b-button variant="link" v-b-toggle="`child-${key}`"><span class="text-black-75"><i class="ri-corner-down-right-line"></i> {{getLocaleText(child, 'header')}}</span></b-button>
                                            <b-button variant="link"
                                                      v-if="checkPermission('ectspage_update')"
                                                      @click="openModal('edit', child, child)"
                                                      class="p-0 font-size-16"
                                                      :title="$t('edit')"><i class="ri-edit-box-fill"></i></b-button>
                                            <b-button variant="link"
                                                      v-if="checkPermission('ectspage_delete')"
                                                      @click="removePage(child)"
                                                      class="pl-1 pr-0 font-size-16"
                                                      :title="$t('delete')"><i class="ri-delete-bin-2-line"></i></b-button>
                                            <b-button variant="link" :class="{'pl-1':true, 'pr-0':true, 'font-size-16':true, 'text-success':child.is_visible ? true : false, 'text-danger':child.is_visible ? false : true}" :title="child.is_visible ? $t('visibility')+' : '+$t('active') : $t('visibility')+' : '+$t('passive')">
                                                <i class="ri-computer-fill"></i>
                                            </b-button>
                                            <b-button variant="link" :class="{'pl-1':true, 'font-size-16':true, 'text-success':child.is_active ? true : false, 'text-danger':child.is_active ? false : true}" :title="child.is_active ? $t('status')+' : '+$t('active') : $t('visibility')+' : '+$t('passive')">
                                                <i class="ri-focus-fill"></i>
                                            </b-button>
                                        </b-col>
                                        <b-col md="12" class="ml-3">
                                            <b-collapse :id="`child-${key}`" :accordion="`my-accordion-2-${index}`">
                                                <b-col md="12">
                                                    <b-button variant="link"
                                                              v-if="checkPermission('ectspage_store')"
                                                              @click="openModal('new', child)"><i class="ri-add-line"></i> {{ $t('add_new') }}</b-button>
                                                </b-col>
                                                <b-row v-for="(child2, key2) in child.children" :key="key2">
                                                    <b-col md="12" class="ml-3 d-flex justify-content-left">
                                                        <b-button variant="link"><span class="text-black-50"><i class="ri-corner-down-right-line"></i> {{getLocaleText(child2, 'header')}}</span></b-button>
                                                        <b-button variant="link"
                                                                  v-if="checkPermission('ectspage_update')"
                                                                  @click="openModal('edit', child2, child2)"
                                                                  class="p-0 font-size-16"
                                                                  :title="$t('edit')"><i class="ri-edit-box-fill"></i></b-button>
                                                        <b-button variant="link"
                                                                  v-if="checkPermission('ectspage_delete')"
                                                                  @click="removePage(child2)"
                                                                  class="pl-1 pr-0 font-size-16"
                                                                  :title="$t('delete')"><i class="ri-delete-bin-2-line"></i></b-button>
                                                        <b-button variant="link" :class="{'pl-1':true, 'pr-0':true, 'font-size-16':true, 'text-success':child2.is_visible ? true : false, 'text-danger':child2.is_visible ? false : true}" :title="child2.is_visible ? $t('visibility')+' : '+$t('active') : $t('visibility')+' : '+$t('passive')">
                                                            <i class="ri-computer-fill"></i>
                                                        </b-button>
                                                        <b-button variant="link" :class="{'pl-1':true, 'font-size-16':true, 'text-success':child2.is_active ? true : false, 'text-danger':child2.is_active ? false : true}" :title="child2.is_active ? $t('status')+' : '+$t('active') : $t('visibility')+' : '+$t('passive')">
                                                            <i class="ri-focus-fill"></i>
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                            </b-collapse>
                                        </b-col>
                                    </b-row>
                                </b-collapse>
                            </b-col>
                        </b-row>
                </b-col>
            </b-row>
            <CommonModal ref="pageModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="closeModal">
                <template v-slot:CommonModalTitle>
                    {{ modalTitle }}
                </template>
                <template v-slot:CommonModalContent>
                    <pages-form v-if="isComponent" :parentData="parentData" :updateData="updateData" @onStore="closeModal"></pages-form>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

// Components
import CommonModal from "@/components/elements/CommonModal"

// Services
import EctsService from "@/services/EctsService"

// Others

// Pages
import PagesForm from "./pagesForm"

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        CommonModal,
        PagesForm
    },
    metaInfo() {
        return {
            title: this.$t('ects_panel')
        }
    },
    data() {
        return {
            modalTitle: '',
            isComponent: false,
            pageData: [],
            parentData: {},
            updateData: {}
        }
    },

    created() {
        this.getData()
    },

    methods: {
        getData(){
            EctsService.getPages().then(response => {
                this.pageData = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        openModal(mode, data, updateData) {
            this.isComponent = true
            this.parentData = data
            this.updateData = updateData
            this.modalTitle = mode === "new" ? this.$t("add_new") : this.$t("edit")
            this.modalTitle += data ? ' :: '+this.getLocaleText(data, 'header') : ""
            this.$refs.pageModal.$refs.commonModal.show()
        },

        closeModal(){
            this.isComponent = false
            this.$refs.pageModal.$refs.commonModal.hide()
            this.getData()
        },

        openCollapse(prefix, index){
            this.$root.$emit('bv::toggle::collapse', prefix+'-'+index)
        },

        removePage(data){
            this.$swal.fire({
                title: this.$t('attention'),
                text: this.$t('are_you_sure_to_delete'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no')
            }).then((result) => {
                if (result.isConfirmed) {
                    EctsService.deletePages(data.id).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.getData()
                    }).catch(e => {
                        this.showErrors(e, null)
                    })
                }
            })
        }
    }
}
</script>

